import * as React from 'react';
import ChangeComplete from '../../components/misc/change-complete';

export type IConfirmAccountDelete = {
  email: string;
};

export default function ConfirmAccountDelete({ email }: IConfirmAccountDelete) {
  return (<>
    <ChangeComplete>
      <div className="row spacer-32">
        <div className="col-12">
          <h3>Your account has been deleted.</h3>
        </div>
      </div>
      <div className="row spacer-80">
        <div className="col-12">
          <p>The email was sent to <span className="email-address">{email}</span></p>
        </div>
      </div>
    </ChangeComplete>
  </>
  );

}
